module.exports = __webpack_public_path__ + "static/healthcare-a2d8e05b7c89ebcd7b0c01cc20517366.png";